export default {
  "value": {
    "sections": [
      {
        "id": 1,
        "name": "Technologie ECS",
        "color": "#0ea5e9",
        "emoji": "🚿"
      },
      {
        "id": 2,
        "name": "Différents Systèmes ECS",
        "color": "#f59e0b",
        "emoji": "⚡"
      },
      {
        "id": 3,
        "name": "Fixation & Pose Apparent",
        "color": "#777783",
        "emoji": "🔧"
      },
      {
        "id": 4,
        "name": "Appareils Sanitaires",
        "color": "#a855f7",
        "emoji": "🚰"
      },
      {
        "id": 5,
        "name": "Poste SOA",
        "color": "#f97316",
        "emoji": "🧯"
      }
    ],
    "categories": [
      {
        "id": 2,
        "name": "Fixations - Pattes à vis",
        "icon": "🔩",
        "sectionId": 3,
        "color": "#3b82f6",
        "subs": [
          {
            "id": 206,
            "title": "Pattes à vis - Types et dimensioning",
            "text": "<p><span style=\"color: rgb(90, 114, 190); font-size: 22px;\"><strong><u>Pattes à vis métal</u></strong></span></p><p><span style=\"color: rgb(59, 81, 221); font-size: 18px;\"><strong>Adaptées aux chevilles métalliques</strong></span></p><p><span style=\"font-size: 16px;\">Ø5 ou Ø6</span></p><p>Longueurs jusqu'à 70 mm</p><p>Support : Cloisons, placos</p><p></p><p><span style=\"color: rgb(59, 81, 221); font-size: 18px;\"><strong>Règles de vissage minimum</strong></span></p><p>🔹 Cheville plastique : 30 mm minimum</p><p>🔹 Bois tendre : 20 mm minimum</p><p>🔹 Bois dur : 10 mm minimum</p><p></p><p><span style=\"color: rgb(248, 33, 57); font-size: 18px;\"><strong>À respecter impérativement</strong></span></p><p><span style=\"color: rgb(219, 149, 61);\">Insuffisant = arrachement garanti</span></p>",
            "color": "#8a96a8",
            "images": [
              {
                "url": "https://mqd1vupq8ii1x4rr.public.blob.vercel-storage.com/uploads/1769296659307-a701bb6acb8228-image-OvfYfFHF9exOBIhYPaCo8STPOaUIB7.jpeg",
                "desc": ""
              }
            ]
          }
        ]
      },
      {
        "id": 3,
        "name": "ECS / Sanitaire",
        "icon": "🚰",
        "sectionId": 1,
        "color": "#06b6d4",
        "subs": [
          {
            "id": 301,
            "title": "Sécurité électrique - Appareils électroportatifs",
            "text": "<p></p><p>⚠️ Plus de <span style=\"color: rgb(251, 191, 36); font-size: 20px;\">1 000</span><span style=\"color: rgb(251, 191, 36);\"> accidents</span> électriques par an en France, dont ~20 mortels.</p><p></p><p>💡 Vérifier l'état général des appareils et rallonges en 230V.</p><p>⚡ 50V en milieu sec peut être létal, 25V en milieu humide.</p><p></p><p><span style=\"color: rgb(219, 149, 61);\">Prévention essentielle</span> : <span style=\"color: rgb(248, 33, 57);\">Utiliser disjoncteur différentiel et équipement personnel.</span></p>",
            "color": "#cffafe",
            "image": null
          },
          {
            "id": 302,
            "title": "Solution batterie",
            "text": "<p></p><p>Utiliser des appareils sur batterie (≤24V) pour le travail en milieu humide.</p><p></p><p>🔋 Plus sûr, idéal pour chantier extérieur ou vide sanitaire avec eau.</p><p></p><p><span style=\"color: rgb(219, 149, 61);\">Recommandation</span> : <span style=\"color: rgb(248, 33, 57);\">Préférer batterie à 230V pour prévention des risques.</span></p>",
            "color": "#cffafe",
            "image": null
          },
          {
            "id": 303,
            "title": "NiMH (Nickel-Métal-Hydrure)",
            "text": "<p>Commercialisées vers 1990 plus performantes que NiCd, pas de cadmium ni plomb.</p><p></p><p>💡 <span style=\"color: rgb(16, 185, 129);\">Faible</span> effet mémoire, écologique</p><p>Durée de vie : 500-1000 cycles</p>",
            "color": "#cffafe",
            "image": null
          },
          {
            "id": 304,
            "title": "Li-ion / Li-Po",
            "text": "<p>Plus grande densité énergétique que NiMH, usage courant sur outils modernes.</p><p></p><p>Avantages : Meilleure puissance, recharge plus rapide </p><p>Durée de vie : 1000+ cycles</p>",
            "color": "#cffafe",
            "image": null
          }
        ]
      },
      {
        "id": 3.5,
        "name": "SOA - Soudure Oxy-Acétylénique",
        "icon": "🔥",
        "sectionId": 4,
        "color": "#f97316",
        "subs": [
          {
            "id": 351,
            "title": "Gaz utilisés - Oxygène & Acétylène",
            "text": "<p><span style=\"color: rgb(70, 162, 210); font-size: 22px;\"><strong><u>Oxygène</u></strong></span></p><p>🔹 Gaz comburant</p><p>🔹 Entretient la combustion</p><p>🔹 Pression haute 200 bar</p><p>🔹 Stockage en bouteille robuste</p><p></p><p><span style=\"color: rgb(186, 128, 94); font-size: 22px;\"><strong>Acétylène</strong></span></p><p>🔹 Gaz carburant</p><p>🔹 Très inflammable</p><p>🔹 Dissous dans acétone</p><p>🔹 Stockage TOUJOURS debout</p><p>🔹 Pression max 1 bar</p><p></p><p><span style=\"font-size: 22px;\"><strong>⚠️</strong></span><span style=\"color: rgb(219, 149, 61); font-size: 22px;\"><strong> DANGER</strong></span></p><p><span style=\"color: rgb(248, 33, 57);\">Ne JAMAIS pencher bouteille acétylène</span></p><p><span style=\"color: rgb(248, 33, 57);\">Risque d'expulsion d'acétone</span></p>",
            "color": "#fed7aa",
            "image": null
          },
          {
            "id": 352,
            "title": "Bouteilles - Stockage & manipulation",
            "text": "<p><span style=\"color: rgb(186, 128, 94); font-size: 22px;\"><strong>Acétylène</strong></span></p><p>✔️ Dissous dans acétone</p><p>✔️ Toujours stockée debout</p><p>✔️ Très inflammable</p><p>✔️ Distance min 10m source feu</p><p>✔️ Ventilation obligatoire</p><p></p><p><span style=\"color: rgb(70, 162, 210); font-size: 22px;\"><strong>Oxygène</strong></span></p><p>✔️ Gaz comburant</p><p>✔️ Favorise violemment la combustion</p><p>✔️ Peut être stockée horizontalement</p><p>✔️ Distance min murs</p><p></p><p><span style=\"color: rgb(219, 149, 61); font-size: 22px;\"><strong>Règles communes</strong></span></p><p>⚠️ <span style=\"color: rgb(248, 33, 57);\">Chaînes d'attache obligatoires</span></p><p><span style=\"color: rgb(248, 33, 57);\">⚠️ Pas de secousses / chocs</span></p><p><span style=\"color: rgb(248, 33, 57);\">⚠️ Capuchons de protection</span></p><p><span style=\"color: rgb(248, 33, 57);\">⚠️ Fiches de sécurité consultées</span></p>",
            "color": "#fed7aa",
            "image": null
          },
          {
            "id": 353,
            "title": "Mano-détendeurs & Débitmètres",
            "text": "<p><span style=\"color: rgb(60, 52, 229); font-size: 22px;\"><strong>Fonction des manodétendeurs</strong></span></p><p>🔹 Réduction pression</p><p>🔹 Réglage précis du débit</p><p>🔹 Protection équipement aval</p><p></p><p><span style=\"color: rgb(99, 251, 29); font-size: 22px;\"><strong>Caractéristiques</strong></span></p><p>📊 Manomètre HP (haute pression)</p><p>📊 Manomètre BP (basse pression)</p><p>🔧 Robinet de réglage fin</p><p></p><p><span style=\"color: rgb(70, 162, 210); font-size: 22px;\"><strong>Oxygène</strong></span></p><p>- Pression sortie : 1-8 bar selon travail</p><p>- Débit : Réglé par débitmètre</p><p></p><p><span style=\"color: rgb(186, 128, 94); font-size: 22px;\"><strong>Acétylène</strong></span></p><p>- Pression sortie : MAX 1 bar</p><p>- Débit : Réglé par débitmètre</p><p>- JAMAIS dépasser 1 bar</p><p></p><p><span style=\"color: rgb(219, 149, 61); font-size: 22px;\"><strong>⚠️ SÉCURITÉ PRIMORDIALE</strong></span></p><p><span style=\"color: rgb(248, 33, 57);\">Vérifier pression avant chaque utilisation</span></p>",
            "color": "#fed7aa",
            "image": null
          },
          {
            "id": 354,
            "title": "Chalumeau - Types et utilisation",
            "text": "<p><span style=\"color: rgb(224, 114, 56); font-size: 22px;\"><strong>Chalumeau soudeur</strong></span></p><p>✔️ Soudure de tubes en cuivre</p><p>✔️ Température flamme : 3200°C</p><p>✔️ Joint métal d'apport</p><p>✔️ Technique : Chauffer + fondre apport</p><p></p><p><span style=\"color: rgb(213, 130, 67); font-size: 22px;\"><strong>Chalumeau réchauffeur</strong></span></p><p>✔️ Déglaçage</p><p>✔️ Dilatation contrôlée</p><p>✔️ Température plus basse</p><p>✔️ Plus gros débit O2</p><p></p><p><span style=\"color: rgb(197, 83, 184); font-size: 22px;\"><strong>Buses adaptées au travail</strong></span></p><p>🔹 N°1, 2 : Tubes fins (6-10 mm)</p><p>🔹 N°3, 4 : Tubes courants (13-20 mm)</p><p>🔹 N°5+ : Gros tubes (25+ mm)</p><p></p><p><span style=\"color: rgb(186, 101, 94); font-size: 22px;\"><strong>Technique soudure</strong></span></p><p>1️⃣ Chauffer tube 2-3 secondes</p><p>2️⃣ Fondre apport progressivement</p><p>3️⃣ Laisser refroidir naturellement</p><p><span style=\"color: rgb(219, 149, 61); font-size: 22px;\"><strong>⚠️ Pas de trempage!</strong></span></p>",
            "color": "#fed7aa",
            "image": null
          }
        ]
      },
      {
        "id": 5,
        "name": "Appareils et Outils - Perforateurs",
        "icon": "⚙️",
        "sectionId": 3,
        "color": "#f59e0b",
        "subs": [
          {
            "id": 501,
            "title": "Sécurité électrique - Appareils électroportatifs",
            "text": "<p>⚠️ **DANGER ÉLECTRIQUE MAJEUR**</p><p></p><p>**Risques mortels en milieu humide :** </p><p>⚡ 50V en milieu sec = peut être létal</p><p>⚡ 25V en milieu humide = LÉTAL</p><p>⚡ Plus de 1 000 accidents électriques/an en France (~20 mortels)</p><p></p><p>**Solutions de sécurité :**</p><p>✔️ Disjoncteur différentiel 30mA obligatoire</p><p>✔️ Rallonges équipées GFCI</p><p>✔️ Appareils sur batterie ≤ 24V recommandé</p><p>✔️ Gants/bottes isolants en milieu humide</p><p></p><p>**En vide sanitaire ou extérieur :**</p><p>👉 Utiliser obligatoirement batterie ≤ 24V</p><p>👉 Jamais d'appareil 230V en milieu humide</p>",
            "color": "#fed7aa",
            "image": null
          },
          {
            "id": 502,
            "title": "Perforateur SDS+ 2 modes 18V - Complet",
            "text": "<p>🔧 **Perçages bois, métal, céramique, béton.**<br><br>**Fiche technique complète :**</p><table style=\"min-width: 50px;\"><colgroup><col style=\"min-width: 25px;\"><col style=\"min-width: 25px;\"></colgroup><tbody><tr><th colspan=\"1\" rowspan=\"1\"><p>Caractéristique</p></th><th colspan=\"1\" rowspan=\"1\"><p>Valeur</p></th></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Voltage</p></td><td colspan=\"1\" rowspan=\"1\"><p>18 V</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Batterie</p></td><td colspan=\"1\" rowspan=\"1\"><p>3.0 Ah NiMH</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Puissance utile</p></td><td colspan=\"1\" rowspan=\"1\"><p>300 W</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Vitesse à vide</p></td><td colspan=\"1\" rowspan=\"1\"><p>0-1100 tr/min</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Coups/min</p></td><td colspan=\"1\" rowspan=\"1\"><p>0-4200 cps/min</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Capacité perçage Bois</p></td><td colspan=\"1\" rowspan=\"1\"><p>30 mm</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Capacité perçage Métal</p></td><td colspan=\"1\" rowspan=\"1\"><p>13 mm</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Capacité perçage Béton</p></td><td colspan=\"1\" rowspan=\"1\"><p>20 mm</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Poids</p></td><td colspan=\"1\" rowspan=\"1\"><p>3,1 kg</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Longueur</p></td><td colspan=\"1\" rowspan=\"1\"><p>295 mm</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Hauteur</p></td><td colspan=\"1\" rowspan=\"1\"><p>195 mm</p></td></tr></tbody></table><p>**Équipements de confort :**</p><p>✔️ Poignée caoutchoutée limite vibrations</p><p>*��️ Moteur avec frein électronique</p><p>✔️ Anti-vibration active</p><p>✔️ Équilibrage arrière</p><p>✔️ Changement rapide outil SDS+</p><p>Avant utilisation :</p><p>⚠️ Vérifier batterie chargée</p><p>⚠️ Vérifier foret bien fixé</p><p>⚠️ Porter EPI (lunettes, gants)</p><p>⚠️ Utiliser poignée latérale en percussion</p>",
            "color": "#fed7aa",
            "image": null
          },
          {
            "id": 503,
            "title": "Forets Béton - Carbure de Tungstène",
            "text": "<p>**Composition : Pointe carbure tungstène**</p><p></p><p>**Caractéristiques :**</p><p>✔️ Dureté maximale</p><p>✔️ Résiste aux vibrations percussion</p><p>✔️ Usure réduite</p><p>✔️ Longue durée de vie</p><p></p><p>**Fixations disponibles :**</p><p>🔹 Queue SDS : Ø6-8 mm</p><p>🔹 Queue SDS+ : Ø6-20 mm</p><p>🔹 Queue SDS Max : Ø18-32 mm  </p><p></p><p>**Utilisation :**</p><p>- Béton armé / non armé</p><p>- Brique / Pierre</p><p>- Carrelage</p><p>- Rotation lente obligatoire</p><p>- Mode percussion actif</p><p></p><p>**Règle vitesse :**</p><p>🧠 Plus le Ø est grand → plus la vitesse doit être lente</p><p>🧠 Ø20mm = vitesse 1 (min)</p><p>🧠 Ø8mm = vitesse 3 (moyen)</p>",
            "color": "#fed7aa",
            "image": null
          },
          {
            "id": 504,
            "title": "Forets Métal - Acier & Alliages",
            "text": "<p>**Composition : Acier ordinaire ou haute vitesse**</p><p></p><p>**Diamètres disponibles :**</p><p>Ø 1 à 13 mm : Queue cylindrique</p><p>Ø 14 à 16 mm : Queue réduite</p><p>Ø 20+ mm : Queue réduite spéciale</p><p></p><p>**Applications :**</p><p>✔️ Acier / Inox</p><p>✔️ Aluminium</p><p>✔️ Alliages légers </p><p>✔️ Fonte (attention cassant)</p><p></p><p>**Technique :**</p><p>- Vitesse élevée (1200+ tr/min)</p><p>- Lubrification recommandée (WD40)</p><p>- Pression progressive</p><p>- Pas de percussion</p><p></p><p>**Mandrin :**</p><p>🔧 Mandrin auto-serrant 1-13mm</p><p>🔧 Pour forets cylindriques</p>",
            "color": "#fed7aa",
            "image": null
          },
          {
            "id": 505,
            "title": "Forets Bois - Vrille & Hélice",
            "text": "<p>**Types courants :**</p><p>🔹 Foret hélicoïdal : Usage général bois</p><p>🔹 Foret vrille : Trous nets sans éclat</p><p>🔹 Foret plat : Gros diamètres rapide</p><p></p><p>**Utilisation :**</p><p>✔️ Bois tendre (pin, sapin)</p><p>✔️ Bois dur (chêne, hêtre) </p><p>✔️ Panneaux contreplaqué</p><p>✔️ Aggloméré</p><p></p><p>**Vitesse selon diamètre :**</p><p>Ø 3-8 mm : 1200-1500 tr/min</p><p>Ø 10-16 mm : 600-900 tr/min</p><p>Ø 18+ mm : 300-600 tr/min</p><p></p><p>**Technique :**</p><p>- Pas de percussion</p><p>- Appui régulier</p><p>- Enlever régulièrement foret</p>",
            "color": "#fed7aa",
            "image": null
          },
          {
            "id": 506,
            "title": "Scie cloche & accessoires",
            "text": "<p>**Scie cloche (trépan)**</p><p>✔️ Trous nets et précis</p><p>✔️ Diamètres : 20-150 mm</p><p>✔️ Passage de tuyaux</p><p>✔️ Trous d'évacuation</p><p></p><p>**Vitesse adaptée :**</p><p>- Ø 30mm : 400 tr/min</p><p>- Ø 50mm : 250 tr/min</p><p>- Ø 100mm : 100 tr/min</p><p></p><p>**Foret pilote :**</p><p>💡 Guide pour perçage exact</p><p>💡 Évite déviation scie</p><p>💡 Sécurité en perçage</p><p></p><p>**Utilisations courantes :** </p><p>✔️ Passage tuyaux plomberie</p><p>✔️ Trous robinetterie</p><p>✔️ Saignées gaines électriques</p><p>✔️ Trous d'évacuation sanitaire</p>",
            "color": "#fed7aa",
            "image": null
          }
        ]
      },
      {
        "id": 6,
        "name": "Outillage manuel",
        "icon": "🔧",
        "sectionId": 3,
        "color": "#ec4899",
        "subs": [
          {
            "id": 601,
            "title": "Modes perçage simple",
            "text": "<p>**Stop de frappe pour perçage bois, métal, céramique.**</p><p></p><p>Utilisation : Fixations légères, travail précis</p><p>Sécurité : Bien positionner la mèche avant de percer </p>",
            "color": "#fbcfe8",
            "image": null
          },
          {
            "id": 602,
            "title": "Modes perçage béton",
            "text": "<p>**Utilisation du marteau et SDS-Plus**, coups par minute élevés pour efficacité.</p><p></p><p>Technique : Appliquer pression progressive</p><p>Protection : EPI obligatoire (lunettes, masque) </p>",
            "color": "#fbcfe8",
            "image": null
          },
          {
            "id": 603,
            "title": "Batteries NiMH 2.6Ah",
            "text": "<p>**Livrée avec chargeur rapide 1h**, poignée latérale réglable.</p><p></p><p>Avantages : Rapidité, autonomie, faible effet mémoire</p><p>Entretien : Stocker en lieu frais et sec </p>",
            "color": "#fbcfe8",
            "image": null
          }
        ]
      },
      {
        "id": 7,
        "name": "Lecture de Plans/Schémas",
        "icon": "📐",
        "sectionId": 2,
        "color": "#10b981",
        "subs": [
          {
            "id": 701,
            "title": "Types de plans - Classifications",
            "text": "<p>**Plan d'implantation**</p><p>🗺️ Vue générale bâtiment</p><p>🗺️ Localisation réseaux</p><p>🗺️ Échelle : 1:100 à 1:200</p><p>🗺️ Usage : Positionnement global</p><p></p><p>**Plan d'exécution**  </p><p>🗺️ Détails constructifs</p><p>🗺️ Cotes précises</p><p>🗺️ Échelle : 1:50</p><p>🗺️ Usage : Chantier terrain</p><p></p><p>**Schéma isométrique**</p><p>🗺️ Représentation 3D</p><p>🗺️ Vue perspective</p><p>🗺️ Cheminement réseaux</p><p>🗺️ Usage : Clarification trajets</p><p></p><p>**Schéma de principe**</p><p>🗺️ Fonctionnement circuit</p><p>🗺️ Symboles simplifiés</p><p>🗺️ Pas à l'échelle</p><p>🗺️ Usage : Comprendre système</p>",
            "color": "#d1fae5",
            "image": null
          },
          {
            "id": 702,
            "title": "Symboles essentiels - Tuyauteries",
            "text": "<p>**Représentation tuyaux :**</p><p></p><p>**Lignes pleines** = Eau froide (EF)</p><p>**Lignes pointillées** = Eaux usées (EU)</p><p></p><p>**Codes couleur standards :**</p><p>- 🔵 Bleu : Eau froide</p><p>- 🔴 Rouge : Eau chaude sanitaire (ECS)</p><p>- 🟤 Marron : Eaux usées / Eaux vannes (EU) </p><p>- ⚫ Noir : Eaux de pluie (EP)</p><p>- 🟢 Vert : Gaz</p><p></p><p>💡 **Important :** Vérifier légende chaque plan</p><p>Certains plans peuvent avoir codes différents</p>",
            "color": "#d1fae5",
            "image": null
          },
          {
            "id": 703,
            "title": "Symboles essentiels - Appareils & Robinetterie",
            "text": "<p>**Appareils sanitaires :**</p><p></p><p>🚽 **WC** : Cuvette vue de dessus</p><p>🚰 **Lavabo** : Rectangle avec robinet</p><p>🚿 **Douche** : Carré avec pommeau/tête</p><p>🛁 **Baignoire** : Rectangle allongé </p><p>🪣 **Évier** : Rectangle avec rebord</p><p>🚲 **Bidet** : Forme spécifique</p><p></p><p>**Robinetterie :**</p><p></p><p>🔧 **Robinet 1/4 tour** : Boule avec levier</p><p>🔧 **Robinet thermostatique** : Cercle T</p><p>🔧 **Clapet anti-retour** : Triangle direction</p><p>🔧 **Soupape sécurité** : Carré avec S</p><p></p><p>**Appareils chauffage :**</p><p>🔥 **Radiateur** : Série rectangles parallèles</p><p>🔥 **Ballon ECS** : Cercle + flèches UP/DOWN</p>",
            "color": "#d1fae5",
            "image": null
          },
          {
            "id": 704,
            "title": "Raccords et Coudes - Symboles",
            "text": "<p>**Raccords courants :**</p><p></p><p>**Té (T)** = Trois raccordements 90°</p><p>✔️ Alimentation distributeur</p><p>✔️ Création branche circuit</p><p></p><p>**Coude 90°** = Changement direction</p><p>✔️ Contournement obstacle</p><p>✔️ Descente/montée  </p><p></p><p>**Croix (X)** = Quatre raccordements</p><p>✔️ Distribution double</p><p>✔️ Croisement réseaux</p><p></p><p>**Raccord (R)** = Jonction deux tubes</p><p>✔️ Même diamètre</p><p>✔️ Continuation ligne</p><p></p><p>**Raccord réduction** = Changement diamètre</p><p>✔️ De gros à fin</p><p>✔️ De fin à gros</p><p></p><p>⚠️ **Toujours respecter orientation plan**</p><p>Rotation/inversion peut changer sens écoulement</p>",
            "color": "#d1fae5",
            "image": null
          },
          {
            "id": 705,
            "title": "Lecture Cotes & Mesures",
            "text": "<p>**Types de cotes :**</p><p></p><p>📏 **Cotes de niveau (hauteur finie)**</p><p>✔️ Sol fini = 0,00m</p><p>✔️ Éviers : +0,90m</p><p>✔️ Robinets douche : +2,00m  </p><p>✔️ Radiateurs : +0,15m min</p><p></p><p>📏 **Cotes d'axes**</p><p>✔️ Entre colonnes</p><p>✔️ Positionnement raccords</p><p>✔️ Axe détermination</p><p></p><p>📏 **Cotes pentes (évacuation)**</p><p>✔️ Eaux usées : 2-3 cm/m (2-3%)</p><p>✔️ Eaux pluviales : 0,5-1 cm/m (0,5-1%)</p><p>✔️ Collecteurs : 1-2 cm/m (1-2%)</p><p></p><p>🧠 **Astuce lecture rapide**</p><p>➡️ Toujours lire plan de gauche à droite</p><p>➡️ Du sol vers le haut</p><p>➡️ Vérifier légende d'abord</p><p>➡️ Noter toutes cotes d'eau</p>",
            "color": "#d1fae5",
            "image": null
          },
          {
            "id": 706,
            "title": "Orientation & Repérage - Entrée/Sortie",
            "text": "<p>**Points essentiels repérage :**</p><p></p><p>🧭 **Nord indiqué**</p><p>✔️ Orientation plan</p><p>✔️ Aide positionnement géographique</p><p></p><p>💧 **Entrée eau**  </p><p>✔️ Généralement gauche plan</p><p>✔️ Source d'alimentation générale</p><p>✔️ Vérifier diamètre arrivée</p><p></p><p>🚱 **Sortie eaux usées**</p><p>✔️ Clairement indiquée</p><p>✔️ Vers réseau collectif</p><p>✔️ Vérifier pente vers sortie</p><p></p><p>🔗 **Zones de raccordement**</p><p>✔️ Repères appar eil par appareil</p><p>✔️ Entrée/ sortie distinctes</p><p>✔️ Pas d'erreur sens circulation</p><p></p><p>⚠️ **À ne JAMAIS confondre**</p><p>❌ Entrée EF avec sortie EU</p><p>❌ ECS avec gaz</p><p>❌ Sens écoulement</p>",
            "color": "#d1fae5",
            "image": null
          },
          {
            "id": 707,
            "title": "Notes complémentaires & Détails constructifs",
            "text": "<p>**Informations à relever systématiquement :**</p><p></p><p>📝 **Dimension tuyauterie**</p><p>🔹 EF : Généralement 12-16 mm</p><p>🔹 ECS : 12-16 mm</p><p>🔹 EU : 32-40 mm (lavabos)</p><p>🔹 EU : 100 mm (WC)  </p><p></p><p>📝 **Isolation tuyaux**</p><p>🔹 ECS : Toujours isolée</p><p>🔹 EF : Rarement isolée</p><p>🔹 Épaisseur isolation : 25-50 mm</p><p></p><p>📝 **Matériaux**</p><p>🔹 Cuivre : Traditionnel, cher</p><p>🔹 PER : Flexible, rapide</p><p>🔹 Multicouche : Polyvalent</p><p>🔹 PVC/PP : Évacuation</p><p></p><p>📝 **Protection / Passage**</p><p>🔹 Gaines de protection</p><p>🔹 Traversée plancher</p><p>🔹 Distance murs (cm)</p><p>🔹 Accessibilité robinets</p><p></p><p>💡 **Astuces professionnelles**</p><p>✔️ Relever toutes mesures</p><p>✔️ Vérifier compatibilité matériel</p><p>✔️ Prévoir points de puisage</p><p>✔️ Marquer cheminement réel vs plan</p><p>✔️ Photos chantier avant fermeture</p>",
            "color": "#d1fae5",
            "image": null
          }
        ]
      },
      {
        "id": 8,
        "name": "Alimentation en Eau (EF / ECS)",
        "icon": "🔵",
        "sectionId": 1,
        "color": "#3b82f6",
        "subs": [
          {
            "id": 801,
            "title": "Définitions et principes",
            "text": "<p>**EF (Eau Froide):** Eau potable du réseau public, 2,5-4 bars, 10-15°C</p><p>**ECS (Eau Chaude):** Eau chauffée, distribution 50-60°C, stockage 55-60°C</p><p>  </p><p>Installation conforme aux normes NF pour sécurité et qualité.</p>",
            "color": "#dbeafe",
            "image": null
          }
        ]
      },
      {
        "id": 900,
        "name": "Les différents systèmes de production",
        "icon": "🧭",
        "sectionId": 2,
        "color": "#0ea5e9",
        "subs": [
          {
            "id": 90001,
            "title": "Panorama",
            "text": "<p>🔥 Instantané • ⚡ Micro-accumulation • 🛢️ Accumulation • 🌀 Semi (tampon)</p><p>Clé terrain : choisir selon simultanéité des puisages, énergie dispo, pertes acceptables. </p>",
            "color": "#e0f2fe",
            "image": null
          }
        ]
      },
      {
        "id": 901,
        "name": "ECS instantanée ou micro accumulation",
        "icon": "⚡",
        "sectionId": 2,
        "color": "#38bdf8",
        "subs": [
          {
            "id": 90101,
            "title": "Indépendants élec/gaz",
            "text": "<p>Instantané élec &lt;2 L : 1,5-7 kW, 1 point proche</p><p></p><p>Micro-accum 5-30 L : 1,5-2 kW, 1-2 points</p><p></p><p>Instantané gaz : échangeur plaques/tubulaire, débit = f(puissance)</p><p></p><p>Vigilance :câble/abonnement élec, longueur tirage, ΔT = (kW×860)/L/h.</p>",
            "color": "#e0f2fe",
            "image": null
          },
          {
            "id": 90102,
            "title": "Principe de fonctionnement",
            "text": "<p>Eau traverse échangeur → chauffe directe → zéro stockage.</p><p>✔️ Pas de pertes statiques</p><p>✔️ Démarrage rapide</p><p>⚠️ Débit/T° dépend de la puissance instantanée.  </p>",
            "color": "#e0f2fe",
            "image": null
          }
        ]
      },
      {
        "id": 902,
        "name": "Instantané + chaudière",
        "icon": "🔥",
        "sectionId": 2,
        "color": "#f97316",
        "subs": [
          {
            "id": 90201,
            "title": "Chaudière murale + échangeur",
            "text": "<p>Priorité ECS : vanne 3 voies ou aquastat détourne la puissance chauffage.</p><p>Échangeur à plaques (compact) ou serpentin cuivre.</p><p>Avantage : compacité, pas de ballon.</p><p>Limite :douche simultanée + évier = chute débit/ΔT.</p>",
            "color": "#ffe4d5",
            "image": null
          }
        ]
      },
      {
        "id": 903,
        "name": "Accumulation",
        "icon": "🛢️",
        "sectionId": 2,
        "color": "#0284c7",
        "subs": [
          {
            "id": 90301,
            "title": "Principe de fonctionnement",
            "text": "<p>Ballon stocke l'énergie, chauffe décorrélée du puisage.</p><p>Pertes statiques à surveiller (isolation, volume).</p>",
            "color": "#dbeafe",
            "image": null
          },
          {
            "id": 90302,
            "title": "Le phénomène de stratification",
            "text": "<p>Chaud en haut, froid en bas → confort + anti-légionelles si 60°C.</p><p>Éviter brassage inutile, placer départ ECS haut du ballon. </p>",
            "color": "#dbeafe",
            "image": null
          },
          {
            "id": 90303,
            "title": "Accumulation électricité",
            "text": "<p>Résistance stéatite/blindée, volume 50-300 L.</p><p>Pilotage HC/HP, anode à contrôler.</p><p>Astuce : stéatite = moins de calcaire sur la résistance.</p>",
            "color": "#dbeafe",
            "image": null
          },
          {
            "id": 90304,
            "title": "Accumulation gaz",
            "text": "<p>Brûleur atmos. + ballon intégré.</p><p>Ventilation/évac conformes.</p><p>Rappel :=contrôle CO, tirage naturel.</p>",
            "color": "#dbeafe",
            "image": null
          },
          {
            "id": 90305,
            "title": "Accumulation solaire",
            "text": "<p>CESI thermosiphon ou forcé.</p><p>Ballon bi-échangeur/combiné, appoint élec/gaz.</p><p>Gain :kWh gratuits, vérifier antigel, vase, soupapes.</p>",
            "color": "#dbeafe",
            "image": null
          },
          {
            "id": 90306,
            "title": "Accumulation thermodynamique",
            "text": "<p>PAC air extrait/ambiant + ballon.</p><p>COP élevé, bruit et refroidissement du local à considérer.</p><p>Éviter les petits volumes d'air fermés.</p>",
            "color": "#dbeafe",
            "image": null
          }
        ]
      },
      {
        "id": 904,
        "name": "Accumulation combinée chauffage",
        "icon": "♨️",
        "sectionId": 2,
        "color": "#0ea5e9",
        "subs": [
          {
            "id": 90401,
            "title": "Ballon combiné",
            "text": "<p>Un ballon pour ECS + chauffage via serpentin.</p><p>Priorité ECS à paramétrer pour éviter douches tièdes.</p><p>Réglage :limiter cycles brûleur, conserver stratification.</p>",
            "color": "#e0f2fe",
            "image": null
          }
        ]
      },
      {
        "id": 905,
        "name": "Semi instantanée",
        "icon": "⏱️",
        "sectionId": 2,
        "color": "#38bdf8",
        "subs": [
          {
            "id": 90501,
            "title": "Principe",
            "text": "<p>Petit tampon + échangeur dimensionné pour lisser les variations.</p><p>Ne couvre pas toute pointe 10 min mais réduit les chutes.</p><p>Entretien : détartrage échangeur.</p>",
            "color": "#e0f2fe",
            "image": null
          }
        ]
      },
      {
        "id": 906,
        "name": "Semi accumulation",
        "icon": "🌀",
        "sectionId": 2,
        "color": "#38bdf8",
        "subs": [
          {
            "id": 90601,
            "title": "Principe",
            "text": "<p>Instantané + ballon tampon dimensionné pour pointe 10 min (Om).</p><p>✔️ Débit soutenu court terme</p><p>✔️ Ballon plus compact qu'accumulation totale</p><p>⚠️ Pertes statiques existantes. </p>",
            "color": "#e0f2fe",
            "image": null
          }
        ]
      },
      {
        "id": 907,
        "name": "Champs d'application",
        "icon": "🧭",
        "sectionId": 2,
        "color": "#0ea5e9",
        "subs": [
          {
            "id": 90701,
            "title": "Guides rapides",
            "text": "<p>Instantané gaz : 1-2 points isolés</p><p>Micro-accum élec : points proches, faible simultanéité</p><p>Accum élec : pavillonnaire HC </p><p>Accum gaz : usage continu, débit soutenu</p><p>Solaire/thermo : conso régulière, économies énergie</p><p>Semi-accum : petits ERP, pointes 10 min assurées</p>",
            "color": "#e0f2fe",
            "image": null
          }
        ]
      },
      {
        "id": 950,
        "name": "Poste mobile SOA",
        "icon": "🧯",
        "sectionId": 5,
        "color": "#fb923c",
        "subs": [
          {
            "id": 95001,
            "title": "Composition & raccordement",
            "text": "<p>### Poste mobile complet </p><p>🧯 Bouteille O₂ + bouteille C₂H₂ (dissous) sur chariot stable </p><p>📈 Mano-détendeurs double mano (HP/BP) sur chaque bouteille </p><p>🧵 Flexibles caoutchouc toilé (O₂ bleu, C₂H₂ rouge) Ø adaptés </p><p>🔗 Raccords rapides LOR : femelle en attente, mâle côté chalumeau</p><table style=\"min-width: 75px;\"><colgroup><col style=\"min-width: 25px;\"><col style=\"min-width: 25px;\"><col style=\"min-width: 25px;\"></colgroup><tbody><tr><th colspan=\"1\" rowspan=\"1\"><p>Élément</p></th><th colspan=\"1\" rowspan=\"1\"><p>Détail</p></th><th colspan=\"1\" rowspan=\"1\"><p>Emoji</p></th></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>O₂</p></td><td colspan=\"1\" rowspan=\"1\"><p>Comburant, ogive blanche</p></td><td colspan=\"1\" rowspan=\"1\"><p>🟦</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>C₂H₂</p></td><td colspan=\"1\" rowspan=\"1\"><p>Carburant, ogive havane</p></td><td colspan=\"1\" rowspan=\"1\"><p>🟥</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Clapets</p></td><td colspan=\"1\" rowspan=\"1\"><p>Anti-retour + pare-flamme</p></td><td colspan=\"1\" rowspan=\"1\"><p>🛡️</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p>Flexibles</p></td><td colspan=\"1\" rowspan=\"1\"><p>6x11 (petit), 9x16 (n°1)</p></td><td colspan=\"1\" rowspan=\"1\"><p>🧵</p></td></tr></tbody></table><p>Important : clapets anti-retour OBLIGATOIRES.</p><p> Si &gt;20 m de flexibles : un au détendeur + un au chalumeau.<br>Attention :toujours chaîner les bouteilles et garder les capuchons en transport ; pas de chocs.</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95002,
            "title": "Sécurité & clapets",
            "text": "<p>### Règles terrain</p><p>🛡️ Chaîner systématiquement les bouteilles (debout, stable)</p><p>🧢 Capuchon en place au transport, robinets fermés dès arrêt</p><p>🌬️ Ventilation obligatoire (haute/basse) dans les zones fermées</p><p>🔥 Distance : C₂H₂ &gt;10 m de flamme/source chaleur </p><p></p><p>Bon réflexe : tester les clapets (soufflage) avant allumage ; vérifier date d'épreuve flexible.</p><p>Interdit :toute graisse/huile sur O₂ ; pas de chiffon gras ni gants souillés à proximité.</p>",
            "color": "#ffedd5",
            "image": null
          }
        ]
      },
      {
        "id": 951,
        "name": "Gaz utilisés en SOA",
        "icon": "🧪",
        "sectionId": 5,
        "color": "#f97316",
        "subs": [
          {
            "id": 95101,
            "title": "Mix O₂ + C₂H₂",
            "text": "<p>🟦 **Oxygène (comburant) : 200 bar, ogive blanche, raccord femelle droite</p><p>🟥 **Acétylène** (carburant) : 15 bar dissous dans acétone, ogive havane, raccord femelle gauche</p><p></p><p>Rôle : O₂ nourrit la flamme, C₂H₂ apporte le carburant.</p><p>Jamais d'huile/graisse sur O₂, pas de C₂H₂ libre &gt;1 bar.</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95102,
            "title": "Compatibilités & interdits",
            "text": "<p>❌ C₂H₂ interdit avec Ag, Hg, Cu &gt;70% (risque explosion)</p><p>❌ Pas de ventilation à l'O₂ pur (combustion violente) </p><p>✔️ Transport : cabine séparée du compartiment bouteilles, capuchons en place</p><p>[color=#ef4444]Rappel :[/color] ne jamais transvaser de gaz d'une bouteille à l'autre.</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95103,
            "title": "Signalétique & odorants",
            "text": "<p>👃 Odeur ail = fuite C₂H₂</p><p>🎨 Code couleurs ogives : blanc (O₂) / havane (C₂H₂)</p><p>Contrôle terrain :* pression résiduelle, date d'épreuve, état filetage.</p><p>Action immédiate :fuite = fermer, ventiler, baliser.</p>",
            "color": "#ffedd5",
            "image": null
          }
        ]
      },
      {
        "id": 952,
        "name": "Bouteilles de gaz SOA",
        "icon": "🛢️",
        "sectionId": 5,
        "color": "#f97316",
        "subs": [
          {
            "id": 95201,
            "title": "Signalétique & marquages",
            "text": "<table style=\"min-width: 150px;\"><colgroup><col style=\"min-width: 25px;\"><col style=\"min-width: 25px;\"><col style=\"min-width: 25px;\"><col style=\"min-width: 25px;\"><col style=\"min-width: 25px;\"><col style=\"min-width: 25px;\"></colgroup><tbody><tr><th colspan=\"1\" rowspan=\"1\"><p>Gaz</p></th><th colspan=\"1\" rowspan=\"1\"><p>Ogive</p></th><th colspan=\"1\" rowspan=\"1\"><p>Volumes</p></th><th colspan=\"1\" rowspan=\"1\"><p>Pression</p></th><th colspan=\"1\" rowspan=\"1\"><p>Position</p></th><th colspan=\"1\" rowspan=\"1\"><p>Raccord</p></th></tr><tr><th colspan=\"1\" rowspan=\"1\"><p>O₂</p></th><td colspan=\"1\" rowspan=\"1\"><p>Blanche</p></td><td colspan=\"1\" rowspan=\"1\"><p>1-10 m³</p></td><td colspan=\"1\" rowspan=\"1\"><p>~200 bar</p></td><td colspan=\"1\" rowspan=\"1\"><p>Debout ou couché</p></td><td colspan=\"1\" rowspan=\"1\"><p>Femelle droite</p></td></tr><tr><th colspan=\"1\" rowspan=\"1\"><p>C₂H₂</p></th><td colspan=\"1\" rowspan=\"1\"><p>Havane</p></td><td colspan=\"1\" rowspan=\"1\"><p>0,8-7 m³</p></td><td colspan=\"1\" rowspan=\"1\"><p>15 bar</p></td><td colspan=\"1\" rowspan=\"1\"><p>Debout / &gt;30°</p></td><td colspan=\"1\" rowspan=\"1\"><p>Femelle gauche</p></td></tr></tbody></table><p>Check terrain :date d'épreuve, poinçon Mines, pression service. Jamais de choc/soleil direct &gt;50°C.</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95202,
            "title": "Transport & stockage",
            "text": "<p>✔️ Capuchon vissé, chaînes serrées, chariot stable</p><p>✔️ Pas de transvasement de gaz (interdit)</p><p>✔️ Fermer bouteille vide (limite évaporation acétone C₂H₂)</p><p>Ne pas coucher l'acétylène en service ; en transport couché : laisser reposer debout avant usage.</p><p>Ventilation : local aéré, détecter les odeurs (ail) signe de fuite C₂H₂.</p>",
            "color": "#ffedd5",
            "image": null
          }
        ]
      },
      {
        "id": 953,
        "name": "Bouteille d'acétylène",
        "icon": "🟥",
        "sectionId": 5,
        "color": "#f97316",
        "subs": [
          {
            "id": 95301,
            "title": "Usage & limites",
            "text": "<p>🟥 Gaz carburant, odeur ail, plus léger que l'air</p><p>✔️ Dissous dans acétone/DMF, pression 15 bar max</p><p>✔️ Raccord femelle à gauche</p><p>Instable &gt;1 bar libre → garder bouteille verticale (&gt;30° mini) et ne jamais purger à vide.</p><p>Bon usage : fermer même vide pour limiter évaporation acétone.</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95302,
            "title": "Transport & repos",
            "text": "<p>🚚 Transport possible couché mais [color=#00c853]repos debout[/color] avant service.</p><p>🧊 Protéger du soleil &gt;50°C, éviter chocs.  </p><p>🛡️ Chaîner systématiquement ; pas d'hydrocarbures à proximité.</p><p>[color=#ef4444]Si échauffement :[/color] fermer, arroser, évacuer.</p>",
            "color": "#ffedd5",
            "image": null
          }
        ]
      },
      {
        "id": 954,
        "name": "Bouteille d'oxygène",
        "icon": "🟦",
        "sectionId": 5,
        "color": "#f97316",
        "subs": [
          {
            "id": 95401,
            "title": "Caractéristiques",
            "text": "<p>🟦 Comburant pur, 200 bar, ogive blanche</p><p>✔️ Raccord femelle à droite</p><p>Interdit: graisse/huile → risque combustion/explosion.</p><p>Astuce :tolère stockage couché mais service idéal debout, vanne protégée.</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95402,
            "title": "Mise en œuvre",
            "text": "<p>✅ Ouvrir très progressivement (évite coup de bélier)</p><p>✅ Souffler la sortie avant montage détendeur</p><p>✅ Ventiler la zone, éloigner solvants/huiles</p><p>Pas de flamme nue lors des essais de fuite (bombe/eau savonneuse uniquement).</p>",
            "color": "#ffedd5",
            "image": null
          }
        ]
      },
      {
        "id": 955,
        "name": "Manomètres & détendeurs",
        "icon": "📊",
        "sectionId": 5,
        "color": "#f97316",
        "subs": [
          {
            "id": 95501,
            "title": "Rôle & réglages",
            "text": "<p>**Fonction :** abaisser, régler, stabiliser le débit.</p><p>📊 Mano HP (bouteille) + BP (sortie) + molette réglage fin</p><p>🔵 O₂ : sortie 1-8 bar selon buse</p><p>🔴 C₂H₂ : sortie max 1 bar (jamais dépasser)</p><p>Procédure montage : purger la sortie, visser à la clé, tester à la bombe à fuite.</p><p>Risque :fuite = arrêt immédiat, ventilation, contrôle eau savonneuse/bombe.</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95502,
            "title": "Bonnes pratiques",
            "text": "<p>✔️ Positionner mano lisible depuis la zone de travail</p><p>✔️ Resserrer sans excès (joints écrasés = fuite)</p><p>✔️ Déverrouiller la vis de détente en fermeture complète après usage</p><p>Surpression : fermer, purger, vérifier clapets.</p>",
            "color": "#ffedd5",
            "image": null
          }
        ]
      },
      {
        "id": 956,
        "name": "Tuyaux gaz & raccords",
        "icon": "🧵",
        "sectionId": 5,
        "color": "#fb923c",
        "subs": [
          {
            "id": 95601,
            "title": "Couleurs & diamètres",
            "text": "<p>**Tuyaux caoutchouc armé** (norme gaz).</p><p>🔵 O₂ : bleu, petit Ø (12 mm env.)</p><p>🟥 C₂H₂ : rouge, gros Ø (14 mm env.)</p><p>📏 Diamètres courants : 6×11 (mini/étoile), 9×16 (n°1)</p><p>Test fuite : eau savonneuse ou bombe détection (jamais flamme).</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95602,
            "title": "Raccordements & LOR",
            "text": "<p>🔗 Raccords rapides LOR : femelle en attente, mâle côté chalumeau</p><p>🛑 Versions STOP-GAZ (coupure auto + clapet) compl��mentaires aux clapets anti-retour</p><p>👉 Ø différents évitent inversion O₂/C₂H₂</p><p>Rappel : clapet anti-retour indispensable au détendeur et au chalumeau si &gt;20 m de flexible.</p>",
            "color": "#ffedd5",
            "image": null
          }
        ]
      },
      {
        "id": 957,
        "name": "Chalumeau soudeur & réchauffeur",
        "icon": "🔥",
        "sectionId": 5,
        "color": "#fb923c",
        "subs": [
          {
            "id": 95701,
            "title": "Choix & réglages",
            "text": "<p>**Basse pression** : P C₂H₂ ≈0,5 bar, P O₂ ≈1 bar (selon buse).</p><p>🔘 Buses étoile par débit (100-200 l/h lances malléables accès réduit).</p><p>✅ Adapter buse au Ø tube (fin/moyen/gros).</p><p>✅ Vérifier stabilité flamme (cône interne bleu net).</p><p>Flamme longue jaune = manque O₂ ; retours de flamme = fermer, purger, contrôler clapets/buses.</p>",
            "color": "#ffedd5",
            "image": null
          },
          {
            "id": 95702,
            "title": "Soudeur vs réchauffeur",
            "text": "<p>**Chalumeau soudeur** : flamme neutre 3200°C, métal d'apport, cordon fin.</p><p>**Chalumeau réchauffeur** : flamme plus large, gros débit O₂, pour dilatation/déglaçage.</p><p>Routine :purge O₂ puis C₂H₂ avant allumage, fermer C₂H₂ puis O��� à l'arrêt.</p><p>[Toujours porter EPI (lunettes teintées, gants anti-chaleur).</p>",
            "color": "#ffedd5",
            "image": null
          }
        ]
      },
      {
        "id": 980,
        "name": "Mitigeurs thermostatiques",
        "icon": "🌡️",
        "sectionId": 4,
        "color": "#10b981",
        "subs": [
          {
            "id": 98001,
            "title": "Principe & sécurité",
            "text": "<p>**Élément cire + vanne 3 voies** : ajuste ouverture EF/ECS.</p><p>✔️ Sécurité 40°C, précision ±0,5°C, réaction ~0,5 s</p><p>✔️ Maintien T° même en cas de perturbation pression</p><p>👉 Versions murales, encastrées, colonnettes pour gorge </p>",
            "color": "#d1fae5",
            "image": null
          }
        ]
      },
      {
        "id": 981,
        "name": "Robinetterie douche/baignoire",
        "icon": "🚿",
        "sectionId": 4,
        "color": "#14b8a6",
        "subs": [
          {
            "id": 98101,
            "title": "Gabarits & entraxes",
            "text": "<p>Entraxe standard 150 mm.</p><p>Alim douche cuivre 14×1 (hors jets hydro).</p><p>Gabarits ou douilles excentrées 90/270 GCU pour réglage.</p><p>Percements gorge : mono Ø35 mm ; bi/tri Ø25 mm. </p><p>Orientation sortie douche vers bas pour ne pas pincer flexible.</p>",
            "color": "#d1fae5",
            "image": null
          },
          {
            "id": 98102,
            "title": "Saignées & protections",
            "text": "<p>Tracer axes (robinetterie ~1,10 m du receveur), saignée en Y.</p><p>Mettre fourreau sur tubes, recuit sur longueur.</p><p>Scellement plâtre/ciment prompt, prévoir trappe de visite si encastré.</p><p>Fixations adaptées support (voir bâti-support ou chevilles adéquates).  </p>",
            "color": "#d1fae5",
            "image": null
          }
        ]
      },
      {
        "id": 982,
        "name": "Éviers & Vidages",
        "icon": "🍽️",
        "sectionId": 4,
        "color": "#22c55e",
        "subs": [
          {
            "id": 98201,
            "title": "Matériaux & poses",
            "text": "Grès/porcelaine, inox, composites.\nPoses : sur meuble, encastré dessus/dessous.\nHauteur 0,85-0,90 m.\nTrop-plein intégré (céramique) ou externe.",
            "color": "#dcfce7",
            "image": null
          },
          {
            "id": 98202,
            "title": "Percements & robinetterie",
            "text": "<p>Pas de sens de pose → perçage selon côté souhaité.</p><p>Mono Ø35 mm ; bi/tri Ø25 mm.</p><p>Perçage : marteau (grès), emporte-pièce Ø32 (inox), scie cloche (résine).</p><p>Raccordement cuivre 14×1, joint sous robinetterie.  </p>",
            "color": "#dcfce7",
            "image": null
          },
          {
            "id": 98203,
            "title": "Vidages & siphons",
            "text": "<p>Bonde + siphon (filetage 1\"1/2 40×49).</p><p>Garde d'eau 5 cm, culot démontable.</p><p>Bibac : 2 bondes + accouplement + siphon, prise LV/LL possible.</p><p>Vidage auto (câble/ressort) courant. </p>",
            "color": "#dcfce7",
            "image": null
          }
        ]
      },
      {
        "id": 983,
        "name": "Baignoires & Vidages",
        "icon": "🛁",
        "sectionId": 4,
        "color": "#16a34a",
        "subs": [
          {
            "id": 98301,
            "title": "Types & dimensions",
            "text": "<p>Formes : sabot, rectang., angle, ovale, ronde, bain-douche, balnéo.</p><p>Matériaux : tôle émaillée, fonte vitrifiée, composites.</p><p>Hauteur 0,42-0,63 m selon pieds/modèle. </p>",
            "color": "#dcfce7",
            "image": null
          },
          {
            "id": 98302,
            "title": "Pose & DTU 60.1",
            "text": "<p>Supporter fond + périphérie (profilés imputrescibles ou maçonnerie hydrofuge).</p><p>Pas de contact direct parois (joint mastic sanitaire continu, fond de joint mousse).</p><p>Trappes de visite pour robinetterie/vidage.</p><p>Balnéo : conserver plots anti-vibratiles, essai eau avant habillage. </p>",
            "color": "#dcfce7",
            "image": null
          },
          {
            "id": 98303,
            "title": "Vidage baignoire",
            "text": "<p>Bonde 49 ou 90 mm + siphon 1\"1/2 (40×49), sortie horizontale orientable.</p><p>Commandes : câble sur trop-plein ou clapet ressort.</p><p>Options : grand débit, siphon ultra-plat, remplissage par trop-plein.</p>",
            "color": "#dcfce7",
            "image": null
          }
        ]
      },
      {
        "id": 984,
        "name": "Fixations sanitaires & bâtis",
        "icon": "🧱",
        "sectionId": 4,
        "color": "#0ea5e9",
        "subs": [
          {
            "id": 98401,
            "title": "Choix fixations par support",
            "text": "<p>Mur béton/brique/plâtre/bois : choisir chevilles adaptées (plein/creux) et charges (lavabo, ballon ECS).</p><p>Charges lourdes : chevilles métal/longues isolant ou scellement taquet bois.</p><p>Toujours respecter diamètres vis/cheville/foret. </p>",
            "color": "#e0f2fe",
            "image": null
          },
          {
            "id": 98402,
            "title": "Bâti-supports",
            "text": "<p>Adossé ou autoportant pour lavabos, bidets, WC suspendus.</p><p>Fixation sur murs pleins ou cloisons selon modèles (plaque plâtre ossature métal : privilégier autoportant).</p><p>Permet pose propre sans solliciter cloison légère. </p>",
            "color": "#e0f2fe",
            "image": null
          }
        ]
      },
      {
        "name": "Évacuation",
        "icon": "🚽",
        "sectionId": 4,
        "color": "#8b5cf6",
        "subs": [
          {
            "id": 401,
            "title": "PVC, PP, Cuivre",
            "text": "<p></p><p>Choisir le matériau selon type d'eau, pression et norme.</p><p></p><p>🔹<span style=\"color: rgb(90, 171, 190);\"><u>PVC</u></span>: Économique, usage courant</p><p>🔹<span style=\"color: rgb(119, 73, 208);\"><u>PP</u></span> : Meilleure résistance chimique</p><p>🔹<span style=\"color: rgb(198, 95, 82);\"><u>Cuivre</u></span> : Durabilité maximale, haut de gamme</p>",
            "color": "#ddd6fe",
            "image": null
          },
          {
            "id": 402,
            "title": "Pentes et diamètres",
            "text": "<p>💡 **Maintenir pente correcte pour écoulement naturel et éviter bouchons**.</p><p></p><p>Pentes recommandées :</p><p>- Eaux usées : 2-3% minimum</p><p>- Eaux pluviales : 0,5-1%</p><p>- Collecteurs : 1-2% </p><p></p><p>Diamètres courants :</p><p>- Lavabo : 32 mm</p><p>- Douche/Baignoire : 40 mm</p><p>- WC : 100 mm</p>",
            "color": "#ddd6fe",
            "image": null
          }
        ]
      }
    ]
  }
};
